import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { CloudinaryVideoAudioProps, getCloud, sizes, sizeType } from './common';
import { StyledCloudinaryVideoPlayer } from './styles';

const transformation = 't_video_optimized';

type CloudinaryVideoPlayerProps = Pick<
  CloudinaryVideoAudioProps,
  'customSize' | 'fileKey' | 'guid' | 'isThumbnail' | 'mediaStorageStatus' | 'width' | 'height' | 'responsiveWidth'
> & { size?: sizeType };
const CloudinaryVideoPlayer: React.FC<CloudinaryVideoPlayerProps> = (props) => {
  const [width, height] = _isEmpty(props.customSize) ? sizes[props.size ?? 'md'] : props.customSize;
  const publicId = props.fileKey ?? props.guid;
  return (
    <StyledCloudinaryVideoPlayer
      $isThumbnail={props.isThumbnail}
      $responsiveWidth={props.responsiveWidth}
      $wrapperHeight={height}
      $wrapperWidth={width}
      cldVid={getCloud(props).video(publicId).addTransformation(transformation)}
      controls={!props.isThumbnail}
      data-testid={`cloudinary-video-player-${publicId}`}
    />
  );
};

export default CloudinaryVideoPlayer;
